module.exports = __webpack_public_path__ + "img/GreenUp.1085ffeb.svg";